import { responsive, spacing, ThemeUICSSObject } from '@apia/theme';

const aiConnectors: ThemeUICSSObject = {
  upsertion: {
    variant: 'layout.common.upsertion',

    '.dynamic_params': {
      display: 'grid',
      gap: spacing(4),
      gridColumn: 'span 4',
      gridTemplateColumns: responsive({
        0: '1fr',
        2: 'repeat(2, 1fr)',
      }),

      h3: {
        gridColumn: 'span 2',
      },
    },
  },
};

export default aiConnectors;
